export default "__VITE_ASSET__BgIhfHpg__"